var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.0714C8 11.8252 8.10536 11.589 8.29289 11.4148C8.48043 11.2407 8.73478 11.1429 9 11.1429H15C15.2652 11.1429 15.5196 11.2407 15.7071 11.4148C15.8946 11.589 16 11.8252 16 12.0714C16 12.3177 15.8946 12.5539 15.7071 12.728C15.5196 12.9022 15.2652 13 15 13H9C8.73478 13 8.48043 12.9022 8.29289 12.728C8.10536 12.5539 8 12.3177 8 12.0714ZM4 6.5C4 6.25373 4.10536 6.01754 4.29289 5.8434C4.48043 5.66926 4.73478 5.57143 5 5.57143H19C19.2652 5.57143 19.5196 5.66926 19.7071 5.8434C19.8946 6.01754 20 6.25373 20 6.5C20 6.74627 19.8946 6.98246 19.7071 7.1566C19.5196 7.33074 19.2652 7.42857 19 7.42857H5C4.73478 7.42857 4.48043 7.33074 4.29289 7.1566C4.10536 6.98246 4 6.74627 4 6.5ZM0 0.928571C0 0.682299 0.105357 0.446113 0.292893 0.271972C0.48043 0.0978315 0.734784 0 1 0H23C23.2652 0 23.5196 0.0978315 23.7071 0.271972C23.8946 0.446113 24 0.682299 24 0.928571C24 1.17484 23.8946 1.41103 23.7071 1.58517C23.5196 1.75931 23.2652 1.85714 23 1.85714H1C0.734784 1.85714 0.48043 1.75931 0.292893 1.58517C0.105357 1.41103 0 1.17484 0 0.928571Z",
    fill: "#73C7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterImg);
export default __webpack_public_path__ + "static/media/filter_img.d09c81ada2ca0d78b4fb10fd21a2e689.svg";
export { ForwardRef as ReactComponent };